// /help/terms - Phase 1 stub. Per task 1.13a.

export function renderHelpTerms(target: HTMLElement): void {
  target.innerHTML = '';
  const article = document.createElement('article');
  article.className = 'help-page';

  article.innerHTML = `
    <h1 class="help-title">Terms</h1>
    <p class="help-body">
      The nostr.gives code is MIT-licensed. The site is provided as-is, use at
      your own risk. We may discontinue games or add new ones at any time as
      we tune the lineup.
    </p>
    <p class="help-body">
      v1 - more detail as the project matures.
    </p>
    <p class="help-back"><a class="help-link" href="#/">Back to home</a></p>
  `;

  target.appendChild(article);
}
